export type { NoticeBannerProps, NoticeBannerVariant } from './NoticeBanner';

export { default as NoticeBanner } from './NoticeBanner';
